<div class="row">
    <div class="container-fluid pl-0 pr-0">
        <div class="row">
            <div class="col-xl-12">
                <div class="card card-header-actions mx-auto">
                    <div class="card-header">
                        Holiday Calendar
                        <div class="float-right">
                            <button data-toggle="modal" class="btn btn-sm btn-primary" (click)="templateDownload()" *ngIf="isTemplateEnable"> Template
                            </button>&nbsp;&nbsp;
                            

                            <input type="file" class="d-none" id="testResults" #testResults
                                (change)="onFileSelected($event)" (click)="testResults.value = null"
                                accept=".xlsx, .xls" >
                            <button class="btn btn-sm btn-success" (click)="testResults.click()" *ngIf="isTemplateEnable"><i
                                    class="fa fa-upload" aria-hidden="true"></i>&nbsp;Upload</button>
                            &nbsp;&nbsp;
                            <button class="btn btn-blue btn-icon float-right" (click)="modalTitle='Add Holiday Details';openModal(false,null)"
                                *ngIf="screennames?.screen_name == 'HolidayCalendar' ? screennames.can_insert : ''">
                                <i class="fa fa-plus"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-striped table-bordered table-sm" style="width: 100%" datatable
                                [dtOptions]="dtOptions" *ngIf="dtReneder">
                                <thead>
                                    <tr>
                                        <th class="text-center">Sl NO</th>
                                        <th>Holiday Name</th>
                                        <th>Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let g of hldyLst;let i=index">
                                        <td class="text-center">{{i+1}}</td>
                                        <td>{{g?.name}}</td>
                                        <td *ngIf="!g.onEdit">{{g?.date | date:'dd-MM-yyy'}}</td>
                                    <td *ngIf="g.onEdit" class="d-inline-flex align-items-center" style="white-space: nowrap;">
                                        <input type="text" class="form-control form-control-sm" style="width: 140px;"
                                            [value]="g.date | date:'dd-MM-yyyy'" (change)="onDateChange(g,$event.target.value)" />
                                        <button class="btn btn-sm btn-success ml-2" (click)="onUpdate(g)" title="Save">
                                            Update
                                        </button>
                                    </td>
                                    
                                    
                                    <td>
                                             <!-- <span>
                                                <a class="badge badge-info badge-pill pointer" title="Edit"  *ngIf="screennames?.screen_name == 'HolidayCalendar' ? screennames?.can_update : ''"
                                                    (click)="onEdit(g)">
                                                    <i class="fa fa-edit text-white"></i></a>&nbsp;
                                            </span> -->
                                             <span>
                                                <a class="badge badge-info badge-pill pointer" title="Edit"  *ngIf="screennames?.screen_name == 'HolidayCalendar' ? screennames?.can_update : ''"
                                                    (click)="modalTitle='Update Holiday Details';openModal(true,g)">
                                                    <i class="fa fa-edit text-white"></i></a>&nbsp;
                                            </span>
                                            <span>
                                                <a class="badge badge-danger badge-pill pointer" title="Delete"
                                                    (click)="onDelete(g)"
                                                    *ngIf="screennames?.screen_name == 'HolidayCalendar' ? screennames?.can_delete : ''">
                                                    <i class="fa fa-trash text-white"></i></a>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot *ngIf="hldyLst.length === 0">
                                    <tr>
                                        <td colspan="3" class="text-bold text-center">No Records to Display</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="addHoliday" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="addHolidayLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header eMdlHdr">
                <h5 class="modal-title" id="addHolidayLabel">{{modalTitle}}</h5>
                <button type="button" class="close btn btn-light float-end eMdlClsBtn"
                 data-dismiss="modal">
                <span aria-hidden="true">&times;</span>
            </button>
            </div>
            <div class="modal-body" [formGroup]="holidayForm">
                <div class="container-fluid pt-4 pb-4">
                    <div class="row">
                        <div class="col-xl-2"></div>
                        <div class="col-xl-3 mb-2">
                            <label class="form-label">Holiday Name<span class="text-danger">*</span> :</label>
                        </div>
                        <div class="col-xl-4 mb-2">
                            <input type="text" class="form-control form-control-sm" formControlName="holiday_name"
                                [ngClass]="{'is-invalid': submitted && fc.holiday_name.errors}">
                            <div *ngIf="submitted && fc.holiday_name.errors" class="invalid-feedback">
                                <div *ngIf="fc.holiday_name.errors['required']">Please enter Holiday Name
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-3"></div>
                        <div class="col-xl-2 mb-2">
                            <label class="form-label ml-2">Date<span class="text-danger">*</span> :</label>
                        </div>
                        <div class="col-xl-4 mb-2">
                          
                    <input type="text" placeholder="DD-MM-YYYY" class="form-control form-control-sm" 
                    formControlName="holiday_date"  [ngClass]="{ 'is-invalid': submitted && fc.holiday_date.errors }"
                    bsDatepicker #dp="bsDatepicker" (focus)="dp.show()" [minDate]="minDate"[maxDate]="maxDate"
                    [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false }">
                    <div *ngIf="submitted && fc.holiday_date.errors" class="invalid-feedback">
                        <div *ngIf="fc.holiday_date.errors.required">Date is required</div>
                    </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-3"></div>
                        <div class="col-xl-2 mb-2">
                            <label class="form-label">Status<span class="text-danger">*</span> :</label>
                        </div>
                        <div class="col-xl-4 mb-2">
                           <div>
                            <input type="radio" formControlName="account_activated" [value]="true">Active
                            <input type="radio" formControlName="account_activated"  [value]="false">In Active
                        </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn btn-primary" (click)="onSubmit()">Save</button>
                <button type="button" class="btn btn-sm btn btn-danger" data-dismiss="modal">Close</button>
                
            </div>
        </div>

    </div>
</div>